import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { colord } from "colord";
import { Input } from "../input/Input";
import { useUniqueId } from "../../hooks/useUniqueId";
import * as Styled from "./ColorField.styled";
export const RGBAInputs = ({ activeColor, disabled, setActiveColor, onColorChange, value, hasVariantLabel = false, gutterAdornment }) => {
    const inputRRef = useRef(null);
    const inputGRef = useRef(null);
    const inputBRef = useRef(null);
    const inputARef = useRef(null);
    const rbgValue = colord(activeColor || "").toRgb();
    const updateValues = () => {
        const inputR = inputRRef.current;
        const inputG = inputGRef.current;
        const inputB = inputBRef.current;
        const inputA = inputARef.current;
        const hexColor = colord({
            r: parseInt(inputR.value, 10),
            g: parseInt(inputG.value, 10),
            b: parseInt(inputB.value, 10),
            a: parseFloat(inputA.value)
        }).toHex();
        setActiveColor(hexColor);
        onColorChange &&
            onColorChange({
                color: hexColor,
                isValidCssColor: colord(hexColor).isValid(),
                opacity: inputA.value
            });
    };
    // Need to validate RGBA because if the value isn't a valid RGBA value colord will automatically return black
    const validateRGBA = (e) => {
        const inputValue = e.target.value;
        if (inputValue !== "") {
            if (e.target.getAttribute("name") === "a") {
                if (parseFloat(inputValue) > 1 || parseFloat(inputValue) < 0) {
                    const inputA = inputARef.current;
                    inputA.value = "1";
                }
                updateValues();
                return;
            }
            if (parseInt(inputValue, 10) < 0 || parseInt(inputValue, 10) > 255) {
                const inputChanging = e.target.getAttribute("name");
                const inputR = inputRRef.current;
                const inputG = inputGRef.current;
                const inputB = inputBRef.current;
                if (inputChanging === "r") {
                    inputR.value = "255";
                }
                if (inputChanging === "g") {
                    inputG.value = "255";
                }
                if (inputChanging === "b") {
                    inputB.value = "255";
                }
            }
            updateValues();
        }
    };
    useEffect(() => {
        const newValue = colord(value || "").toRgb();
        setActiveColor(colord(newValue).toHex());
        if (newValue !== undefined && inputRRef.current && newValue.r !== parseInt(inputRRef.current.value, 10)) {
            const inputR = inputRRef.current;
            inputR.value = newValue.r.toString();
        }
        if (newValue !== undefined && inputGRef.current && newValue.g !== parseInt(inputGRef.current.value, 10)) {
            const inputG = inputGRef.current;
            inputG.value = newValue.g.toString();
        }
        if (newValue !== undefined && inputBRef.current && newValue.b !== parseInt(inputBRef.current.value, 10)) {
            const inputB = inputBRef.current;
            inputB.value = newValue.b.toString();
        }
        if (newValue !== undefined && inputARef.current && newValue.a !== parseInt(inputARef.current.value, 10)) {
            const inputA = inputARef.current;
            inputA.value = newValue.a.toString();
        }
    }, [setActiveColor, value]);
    const r_id = useUniqueId("r");
    const g_id = useUniqueId("g");
    const b_id = useUniqueId("b");
    const a_id = useUniqueId("a");
    return (_jsxs(_Fragment, { children: [_jsxs(Styled.ColorFieldRgbaWrapper, { hasVariantLabel: hasVariantLabel, children: [_jsx(Input, { id: r_id, ref: inputRRef, name: "r", type: "number", min: "0", max: "255", defaultValue: rbgValue.r, onBlur: (e) => validateRGBA(e), disabled: disabled }), _jsx(Input, { id: g_id, ref: inputGRef, name: "g", type: "number", min: "0", max: "255", defaultValue: rbgValue.g, onBlur: (e) => validateRGBA(e), disabled: disabled }), _jsx(Input, { id: b_id, ref: inputBRef, name: "b", type: "number", min: "0", max: "255", defaultValue: rbgValue.b, onBlur: (e) => validateRGBA(e), disabled: disabled }), _jsx(Input, { id: a_id, ref: inputARef, name: "a", type: "number", min: "0", max: "1", step: ".1", defaultValue: rbgValue.a, onBlur: (e) => validateRGBA(e), disabled: disabled }), _jsxs(_Fragment, { children: [_jsx(Styled.RGBAInputLabel, { htmlFor: r_id, children: "r" }), _jsx(Styled.RGBAInputLabel, { htmlFor: g_id, children: "g" }), _jsx(Styled.RGBAInputLabel, { htmlFor: b_id, children: "b" }), _jsx(Styled.RGBAInputLabel, { htmlFor: a_id, children: "a" })] })] }), _jsx(Styled.ColorFieldRgbaWrapperControl, { children: gutterAdornment })] }));
};
